import { useCallback, useEffect, useRef, useState } from "react";
import { END } from "./timeline";

export function usePlayback({ speed = 1, autoplay = true, initialT = 0 } = {}) {
  const [frame, setFrame] = useState({ t: initialT, clock: 0 });
  const [playing, setPlaying] = useState(autoplay);
  const tRef = useRef(initialT);
  const clockRef = useRef(0);
  const speedRef = useRef(speed);
  const playingRef = useRef(autoplay);
  speedRef.current = speed;
  playingRef.current = playing;

  useEffect(() => {
    let raf;
    let last = performance.now();
    const loop = (now) => {
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      clockRef.current += dt;
      if (playingRef.current && tRef.current < END) {
        tRef.current = Math.min(END, tRef.current + dt * speedRef.current);
        if (tRef.current >= END) setPlaying(false);
      }
      setFrame({ t: tRef.current, clock: clockRef.current });
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  const replay = useCallback(() => {
    tRef.current = 0;
    setPlaying(true);
  }, []);
  const seek = useCallback((v) => {
    tRef.current = Math.max(0, Math.min(END, v));
    setPlaying(false);
  }, []);
  const toggle = useCallback(() => {
    if (tRef.current >= END) tRef.current = 0;
    setPlaying((p) => !p);
  }, []);
  const play = useCallback(() => setPlaying(true), []);

  return { ...frame, playing, replay, seek, toggle, play, done: frame.t >= END };
}
